import React, { useState } from 'react';
import ProductCard from '../ProductCard';
import Filters from '../Filters';
import Groups from '../Groups';
import FiltersIcon from '../Filters/FiltersIcon';
import MobileModal from '../MobileModal';
import Sort from '../Sort';
import Pagination from '../Pagination';
import ZeroResults from './ZeroResults/ZeroResults';
import Spinner from '../Spinner';
import { RequestStatus } from './reducer';
import { isPlpSearchDataRedirect } from '../../utils';
import { useCioPlpContext } from '../../hooks/useCioPlpContext';
import useCioPlp from '../../hooks/useCioPlp';
import Breadcrumbs from '../Breadcrumbs';
export default function CioPlpGrid(props) {
    const { spinner, initialSearchResponse, initialBrowseResponse, filterConfigs, sortConfigs, paginationConfigs, groupsConfigs, children, } = props;
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const plpData = useCioPlp({
        initialSearchResponse,
        initialBrowseResponse,
    });
    const { isSearchPage, isBrowsePage, searchQuery, browseFilterValue, data, status, filters, sort, plpContainerCnstrcDataAttributes, } = plpData;
    const { callbacks: { onRedirect = (redirectUrl) => window.location.replace(redirectUrl) }, } = useCioPlpContext();
    if (isPlpSearchDataRedirect(data)) {
        const redirectUrl = data.redirect.data.url;
        if (onRedirect) {
            onRedirect(redirectUrl);
        }
        return null;
    }
    if (!isSearchPage && !isBrowsePage) {
        // Render Zero results page in the case where no query is provided
        // TODO: Allow customers to override default page
        return React.createElement(ZeroResults, null);
    }
    let renderHeader;
    if (isSearchPage) {
        renderHeader = (React.createElement("span", { className: 'cio-products-header-title' },
            React.createElement("b", null, data?.response?.totalNumResults),
            " results",
            searchQuery && (React.createElement(React.Fragment, null,
                "\u00A0for ",
                React.createElement("b", null,
                    "\"",
                    searchQuery,
                    "\"")))));
    }
    else if (isBrowsePage && data?.request.browse_filter_name === 'group_id') {
        renderHeader = (React.createElement(Breadcrumbs, { groups: data?.response.groups || [], filterValue: browseFilterValue || '' }));
    }
    return (React.createElement(React.Fragment, null, typeof children === 'function' ? (children(plpData)) : (React.createElement(React.Fragment, null,
        status === RequestStatus.FETCHING && (spinner || React.createElement(Spinner, null)),
        status !== RequestStatus.FETCHING && data && (React.createElement(React.Fragment, null, data.response?.results?.length ? (React.createElement("div", { className: 'cio-plp-grid' },
            React.createElement("div", { className: 'cio-filters-container cio-large-screen-only' },
                isSearchPage && React.createElement(Groups, { groups: data.response.groups, ...groupsConfigs }),
                React.createElement(Filters, { facets: filters.facets, ...filterConfigs })),
            React.createElement("div", { className: 'cio-products-container', ...plpContainerCnstrcDataAttributes },
                React.createElement("div", { className: 'cio-products-header-container' },
                    React.createElement("div", { className: 'cio-mobile-products-header-wrapper cio-mobile-only' }, renderHeader),
                    React.createElement("div", { className: 'cio-products-header-wrapper' },
                        React.createElement("button", { type: 'button', className: 'cio-filters-modal-button cio-mobile-only', onClick: () => setIsFilterOpen(!isFilterOpen) },
                            FiltersIcon,
                            "Filters"),
                        React.createElement("span", { className: 'cio-large-screen-only' }, renderHeader),
                        React.createElement(Sort, { sortOptions: sort.sortOptions, isOpen: false, ...sortConfigs }))),
                React.createElement("div", { className: 'cio-product-tiles-container' },
                    React.createElement(MobileModal, { isOpen: isFilterOpen, setIsOpen: setIsFilterOpen },
                        React.createElement(Filters, { facets: filters.facets })),
                    data.response?.results?.map((item) => (React.createElement("div", { className: 'cio-product-tile', key: item.itemId },
                        React.createElement(ProductCard, { key: item.itemId, item: item }))))),
                React.createElement("div", { className: 'cio-pagination-container' },
                    React.createElement(Pagination, { totalNumResults: data.response.totalNumResults, resultsPerPage: data.response.numResultsPerPage, ...paginationConfigs }))))) : (React.createElement("div", { ...plpContainerCnstrcDataAttributes },
            React.createElement(ZeroResults, null)))))))));
}
